const Refreshment = (state) => state.Refreshment
const RefreshmentInfo = (state) => state.refreshmentInfo
const Currencies = (state) => state.Currencies
const Countrys = (state) => state.Countrys
const dataBank = (state) => state.dataBank
const RefreshmentPrice = (state) => state.refreshmentPrice
const dataInfoBankPax = (state) => state.dataInfoBankPax

export default {
  Refreshment,
  RefreshmentInfo,
  Currencies,
  dataBank,
  RefreshmentPrice,
  dataInfoBankPax,
  Countrys
}
